import { useMenuQuery } from "../../core/hooks/use-menu-query.js";
import { searchMenuByLabel } from "../utils/search.js";
import { useCallback, useMemo, useState } from "react";
import { useDebouncedState } from "@tecsinapse/cortex-react";
//#region src/modules/menubar/hooks/use-menu.ts
var useMenu = () => {
	const { data: menu, isLoading, error } = useMenuQuery();
	const [searchTerm, setSearchTerm] = useState("");
	const [inputSearch, setInputSearch] = useDebouncedState("", setSearchTerm);
	return {
		options: useMemo(() => {
			return searchMenuByLabel(menu?.menus ?? [], searchTerm);
		}, [menu, searchTerm]),
		inputSearch,
		handleSearch: useCallback((e) => {
			setInputSearch(e.target.value);
		}, [setInputSearch]),
		isLoading,
		error
	};
};
//#endregion
export { useMenu };
